import { handleError, handleLongText, toTitleCase } from 'config/libraries';
import React, { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';

export const DaftarAduan = () => {

    const [DataResponse, setDataResponse] = useState([]);
    const [FadeClassName, setFadeClassName] = useState('fade-costum hide');
    const [DataResponseKategori, setDataResponseKategori] = useState([]);
    const [Pagination, setPagination] = useState({
        pageCount: 0,
        currentPage: 1
    });

    useEffect(() => {
        setFadeClassName('fade-costum hide')
        getDataResponse(1)
        return () => {
            setDataResponse(null);
            setFadeClassName('fade-costum hide');
        };
    }, []);

    function getDataResponse(page = 1) {

        const axios = require('axios');
        axios.get(process.env.REACT_APP_SERVER_BASE_URL +'/unit-layanan-aduan?per_page=5&page=' + page).then(function (response) {
            setDataResponse(response.data.data.data);
            setPagination({
                pageCount: response.data.data.last_page,
                currentPage: response.data.data.current_page
            })
            setTimeout(() => {
                setFadeClassName('fade-costum')
            }, 300);
        }).catch(function (error) {
            handleError(error)
        })
    }

    function handlePageClick(params) {
        getDataResponse(parseInt(params.selected) + 1);
        setDataResponse(null);
        setFadeClassName('fade-costum hide');
    }

    return (
        <div className="jl_sidebar_w">
            <div id="sprasa_recent_post_text_widget-9" className="widget post_list_widget">
                <div className="widget_jl_wrapper">
                    <div className="ettitle">
                        <div className="widget-title">
                            <h2 className="jl_title_c">Daftar Aduan</h2>
                        </div>
                    </div>
                    <div className={'bt_post_widget ' + FadeClassName}>
                        {
                            DataResponse && DataResponse.map((item, index) => {
                                return (
                                    <div key={index} className="jl_m_right jl_sm_list jl_ml jl_clear_at">
                                        <div className="jl_m_right_w">
                                            {/* <div className="jl_m_right_img jl_radus_e">
                                                <Link to={'/berita/' + item.slug_berita}>
                                                    <img width={100} height={100} src={item.gambar_berita} className="attachment-sprasa_small_feature size-sprasa_small_feature wp-post-image fixed-image-100" alt="" loading="lazy" />
                                                </Link>
                                            </div> */}
                                            <div className="jl_m_right_content2">
                                            <Link to={'/unit-layanan-aduan/' + item.slug_keluhan}>
                                                <div>
                                                <h2 className="entry-title mb-2">{handleLongText(item.judul_keluhan, 50)}</h2>
                                                <p>{handleLongText(item.isi_keluhan, 120)}</p>
                                                </div>
                                                
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    {
                        (DataResponse != null && DataResponse.length > 0) ?
                        (Pagination.pageCount > 1) ? 
                        <div className="container-pagination">
                            <ReactPaginate
                                breakLabel="..."
                                nextLabel="next >"
                                onPageChange={handlePageClick}
                                pageRangeDisplayed={5}
                                forcePage={parseInt(Pagination.currentPage) - 1}
                                pageCount={Pagination.pageCount}
                                containerClassName={'pagination'}
                                subContainerClassName={'pages pagination'}
                                activeClassName={'active'}
                                previousLabel="< previous"
                                renderOnZeroPageCount={null}
                            />
                            </div> : <p className='no-data-pagination'>Seluruh data sudah ditampilkan !...</p> : ''
                        }
                </div>
            </div>

            {/* {
                (page_type === 'berita' || page_type === 'artikel') ?
                <div id="sprasa_ads300x250_widget-2" className="widget jellywp_ads300x250_widget">
                    <div className="widget_jl_wrapper ads_widget_container">
                        <div className="widget-title">
                            <h2 className="jl_title_c">Kategori { toTitleCase(page_type) }</h2>
                        </div>
                        <div className="tag-cat">
                            <ul className="single_post_tag_layout">
                            {
                                (page_type === 'berita') ?
                                    <li>
                                        {
                                            DataResponseKategori && DataResponseKategori.map((item, index) => {
                                                return (
                                                    <Link key={index} to={item.slug_kategori_berita} rel={item.nama_kategori_berita}>{item.nama_kategori_berita}</Link>
                                                )
                                            })
                                        }
                                    </li> :
                                (page_type === 'artikel') ?
                                    <li>
                                        {
                                            DataResponseKategori && DataResponseKategori.map((item, index) => {
                                                return (
                                                    <Link key={index} to={item.slug_kategori_artikel} rel={item.nama_kategori_artikel}>{item.nama_kategori_artikel}</Link>
                                                )
                                            })
                                        }
                                    </li> : ''
                            }
                               
                            </ul>
                        </div>
                    </div>
                </div> : ''
            } */}
            
        </div>
    )
};